// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + (chunkId === 180 ? "App" : chunkId) + "." + {"180":"299e1d36","453":"d4a7b449"}[chunkId] + ".chunk.js");